import itemHtml from './itemHtml';
import Filter from './Filter';

var index = {

    init: function () {
        ZoneObject.create('[data-section-event]', {
            run: () => {
                items.create({
                    name: 'event',
                    data: Filter,
                    html: itemHtml,
                    glueUnions: true,
                    first_load: true
                });

                items.create({
                    name: 'event-random',
                    glueUnions: true,
                    data: () => {
                        var data = Filter();

                        if (location.pathname == '/' || location.href.indexOf('industry') > -1) {
                            data.paginate = 3;
                        }

                        return data;
                    },
                    scroll_window: index.isScroll(),
                    html: itemHtml,
                    first_load: true,
                    onAfterLoad: function (response) {
                        if (response && response.data) {
                            if (response.data.length) {
                                $('[random-block]').show();
                            } else {
                                $('[random-block]').hide();
                            }
                        }
                    }
                });

                $('[data-event] [name]').on('change', function () {
                    items.update('event');
                    items.update('event-random');
                });

                $('[data-target-page]').on('click', function (e) {
                    e.preventDefault();
                    window.location = $(this).data('target-page');
                })
            }
        });

        $(document).on('change', '[data-event-filter] [name]', (e) => {
            let filter = $('[data-event-filter]').serialize();

            if (filter) {
                ['location_id', 'industry_id'].forEach(key => {
                    if (filter.indexOf(key + '[]') == -1 && filter.indexOf(key) > -1) {
                        filter = filter.replace(new RegExp(key, "g"), key + '[]');
                    }
                });

                filter = filter.replace(new RegExp('%5B%5D', "g"), '[]');
            }

            history.pushState(false, false, location.pathname + (filter ? '?' + filter : ''));

            $('[data-filter-pdf]').attr('href', filter ? '/events/pdf?' + filter : '/events/pdf');
        });

        $('[data-filter-pdf]').attr('href', '/events/pdf');
    },

    isScroll: () => {
        return location.href.indexOf('account') > -1 || location.href.indexOf('event') > -1;
    }

}

$(index.init);